import ElementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'
import SelectManager from 'assets/core/js/module/selectManager'
import type { TravelerSelector, TravelerValues } from '@ui/TravelerSelector/component'

const hasTravelerSelector = document.getElementById('capacity_traveler_selector-travelerselector') !== null

export const getCapacity = (): string => {
  if (!hasTravelerSelector) {
    return SelectManager.getValue('capacity') as string
  }

  const travelerSelectorEl = document.getElementById('capacity_traveler_selector-travelerselector') as HTMLElement

  if (!travelerSelectorEl) {
    return ''
  }

  const travelerSelector = ElementPropertiesManager.getProperty<TravelerSelector>(travelerSelectorEl, 'travelerSelector')

  if (!travelerSelector) {
    return ''
  }

  return JSON.stringify(travelerSelector.getValues())
}

export const setCapacity = (value: null | string): void => {
  if (!hasTravelerSelector) {
    SelectManager.setValue('capacity', value ?? '')
    return
  }

  const values = value !== null ? JSON.parse(value) : null
  const travelerSelectorEl = document.getElementById('capacity_traveler_selector-travelerselector') as HTMLElement

  if (!travelerSelectorEl) {
    return
  }

  const travelerSelector = ElementPropertiesManager.getProperty<TravelerSelector>(travelerSelectorEl, 'travelerSelector')

  if (!travelerSelector) {
    return
  }

  travelerSelector.setValues(values as TravelerValues)
}
